<!-- git/truth-first-look/src/components/dashboard/PostActionBar.tsx -->
<div class="flex items-center justify-between mt-3 -ml-1.5 max-w-md relative" (click)="$event.stopPropagation()">
  <button type="button" aria-label="Reply" class="group flex items-center gap-1.5 transition-colors duration-200 text-muted-foreground hover:text-ts-blue">
    <span class="p-1.5 rounded-full transition-colors duration-200 group-hover:bg-ts-blue/10">
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round">
        <path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z" />
      </svg>
    </span>
    <span *ngIf="commentCount > 0" class="text-[13px] tabular-nums leading-none">{{ commentCount }}</span>
  </button>

  <div class="relative">
    <button
      type="button"
      aria-label="Repost"
      (click)="toggleRepostMenu($event)"
      class="group flex items-center gap-1.5 transition-colors duration-200 hover:text-emerald-500"
      [ngClass]="isReposted ? 'text-emerald-500' : 'text-muted-foreground'">
      <span class="p-1.5 rounded-full transition-colors duration-200 group-hover:bg-emerald-500/10">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round">
          <path d="M17 1l4 4-4 4" />
          <path d="M3 11V9a4 4 0 0 1 4-4h14" />
          <path d="M7 23l-4-4 4-4" />
          <path d="M21 13v2a4 4 0 0 1-4 4H3" />
        </svg>
      </span>
      <span *ngIf="repostCount > 0" class="text-[13px] tabular-nums leading-none">{{ repostCount }}</span>
    </button>
    <ng-container *ngIf="showRepostMenu">
      <div class="fixed inset-0 z-40" (click)="closeRepostMenu()"></div>
      <div class="absolute left-0 top-full mt-1 z-50 w-40 bg-card rounded-xl border border-border shadow-lg overflow-hidden animate-fade-in">
        <button type="button" (click)="toggleReposted()" class="w-full flex items-center gap-2.5 px-3.5 py-2.5 text-sm text-foreground hover:bg-secondary transition-colors">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round">
            <path d="M17 1l4 4-4 4" />
            <path d="M3 11V9a4 4 0 0 1 4-4h14" />
            <path d="M7 23l-4-4 4-4" />
            <path d="M21 13v2a4 4 0 0 1-4 4H3" />
          </svg>
          {{ isReposted ? 'Undo Repost' : 'Repost' }}
        </button>
        <button type="button" (click)="closeRepostMenu()" class="w-full flex items-center gap-2.5 px-3.5 py-2.5 text-sm text-foreground hover:bg-secondary transition-colors">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round">
            <path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z" />
          </svg>
          Quote
        </button>
      </div>
    </ng-container>
  </div>

  <button
    type="button"
    aria-label="Like"
    (click)="toggleLiked($event)"
    class="group flex items-center gap-1.5 transition-colors duration-200 hover:text-rose-500"
    [ngClass]="isLiked ? 'text-rose-500' : 'text-muted-foreground'">
    <span class="p-1.5 rounded-full transition-colors duration-200 group-hover:bg-rose-500/10">
      <svg *ngIf="!isLiked" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round">
        <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" />
      </svg>
      <svg *ngIf="isLiked" width="18" height="18" viewBox="0 0 24 24" fill="currentColor" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round">
        <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" />
      </svg>
    </span>
    <span *ngIf="likeCount > 0" class="text-[13px] tabular-nums leading-none">{{ likeCount }}</span>
  </button>

  <button
    type="button"
    aria-label="Score"
    (click)="toggleScored($event)"
    class="group flex items-center gap-1.5 transition-colors duration-200 hover:text-amber-500"
    [ngClass]="isScored ? 'text-amber-500' : 'text-muted-foreground'">
    <span class="p-1.5 rounded-full transition-colors duration-200 group-hover:bg-amber-500/10">
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round">
        <defs>
          <linearGradient [attr.id]="gradientId" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stop-color="hsl(42, 90%, 55%)" />
            <stop offset="100%" stop-color="hsl(30, 85%, 50%)" />
          </linearGradient>
        </defs>
        <path *ngIf="isScored" d="M12 2L9 9H2l5.5 4.5L5.5 21 12 16.5 18.5 21l-2-7.5L22 9h-7L12 2z" [attr.stroke]="'url(#' + gradientId + ')'" [attr.fill]="'url(#' + gradientId + ')'" />
        <g *ngIf="!isScored">
          <path d="M12 2L9 9H2l5.5 4.5L5.5 21 12 16.5 18.5 21l-2-7.5L22 9h-7L12 2z" stroke="currentColor" fill="none" />
          <circle cx="12" cy="12" r="3" stroke="currentColor" fill="none" stroke-width="1.5" />
        </g>
      </svg>
    </span>
    <span *ngIf="scoreCount > 0" class="text-[13px] tabular-nums leading-none">{{ scoreCount }}</span>
  </button>

  <div class="flex items-center gap-0.5">
    <button
      type="button"
      aria-label="Bookmark"
      (click)="toggleBookmarked($event)"
      class="group flex items-center gap-1.5 transition-colors duration-200 hover:text-ts-blue"
      [ngClass]="isBookmarked ? 'text-ts-blue' : 'text-muted-foreground'">
      <span class="p-1.5 rounded-full transition-colors duration-200 group-hover:bg-ts-blue/10">
        <svg *ngIf="!isBookmarked" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round">
          <path d="M19 21l-7-5-7 5V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z" />
        </svg>
        <svg *ngIf="isBookmarked" width="18" height="18" viewBox="0 0 24 24" fill="currentColor" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round">
          <path d="M19 21l-7-5-7 5V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z" />
        </svg>
      </span>
    </button>
    <button type="button" aria-label="Share" class="group flex items-center gap-1.5 transition-colors duration-200 text-muted-foreground hover:text-ts-blue">
      <span class="p-1.5 rounded-full transition-colors duration-200 group-hover:bg-ts-blue/10">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round">
          <path d="M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8" />
          <polyline points="16 6 12 2 8 6" />
          <line x1="12" y1="2" x2="12" y2="15" />
        </svg>
      </span>
    </button>
  </div>
</div>
